import { FolderIcon } from '@heroicons/react/solid';

export function EnabledFolderIcon() {
  return <FolderIcon className="h-full text-folder-enabled" />;
}
